import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseConfigurationService } from '../services/base-configuration.service';

export function backEndpointInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  // Una URL ya absoluta se deja pasar: prefijarla daría `backEndpoint + https://…`.
  // Lo usa el motor de turnos, que vive en otro API Gateway.
  if (/^https?:\/\//i.test(req.url)) {
    return next(req);
  }
  if (
    req.url.includes('i18n/') ||
    req.url.includes('icons/') ||
    req.url.includes('api/') ||
    req.url.includes('solver/')
  ) {
    return next(req);
  }
  const baseConf = inject(BaseConfigurationService);
  const dupReq = req.clone({
    url: `${baseConf.getBackendEndpoint()}${req.url}`,
  });
  return next(dupReq);
}
